import { Link, usePage } from '@inertiajs/react'
import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import logotypeSrc from '@/assets/zaytuna-college-logotype.png'
import { cx } from '@/lib/cx'

export function Logotype({ href = '/', suffix, className }: { href?: string; suffix?: ReactNode; className?: string }) {
  return (
    <Link href={href} className={cx('logotype', className)}>
      <img
        src={logotypeSrc}
        alt="Zaytuna College"
        className="logotype__image"
        width={640}
        height={265}
      />
      {suffix != null && <span className="logotype__suffix">{suffix}</span>}
    </Link>
  )
}

function isActive(currentUrl: string, href: string, end?: boolean): boolean {
  const path = currentUrl.split('?')[0]
  if (end) return path === href
  return path === href || path.startsWith(`${href}/`)
}

type NavLinkProps = {
  href: string
  label: string
  icon?: LucideIcon
  /** Overrides URL-based detection (used by tests and previews). */
  active?: boolean
  /** Require an exact URL match rather than prefix match (see NavItem['end']). */
  end?: boolean
}

export function SidebarLink({ href, label, icon: Icon, active, end }: NavLinkProps) {
  const { url } = usePage()
  const isCurrent = active ?? isActive(url, href, end)
  return (
    <Link
      href={href}
      className="sidebar-link"
      data-active={isCurrent || undefined}
      aria-current={isCurrent ? 'page' : undefined}
    >
      {Icon != null && <Icon size={18} aria-hidden="true" />}
      {label}
    </Link>
  )
}

export function BottomBarItem({ href, label, icon: Icon, active, end }: NavLinkProps) {
  const { url } = usePage()
  const isCurrent = active ?? isActive(url, href, end)
  return (
    <Link
      href={href}
      className="bottom-bar-item"
      data-active={isCurrent || undefined}
      aria-current={isCurrent ? 'page' : undefined}
    >
      {Icon != null && <Icon size={20} aria-hidden="true" />}
      {label}
    </Link>
  )
}

/** Underline tab used in the applicant Home + Profile top bar. */
export function TopNavTab({ href, label, active, end }: NavLinkProps) {
  const { url } = usePage()
  const isCurrent = active ?? isActive(url, href, end)
  return (
    <Link
      href={href}
      className="top-nav-tab"
      data-active={isCurrent || undefined}
      aria-current={isCurrent ? 'page' : undefined}
    >
      {label}
    </Link>
  )
}
